import {resolveBackground} from '#core/utils/color-utils.js';

import {CLOSE_BUTTON_TYPES, generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

export function dialogsConfig(PALETTE) {
    const {FONT} = PALETTE;

    return {
        Dialog: {
            background: resolveBackground(PALETTE.DIALOGS_CONTAINER_BG),
            borderStyle: {
                borderRadius: PALETTE.DIALOGS_CONTAINER_BORDER_RADIUS,
            },
            header: {
                container: {
                    style: {
                        padding: 0, // override mojito defaults
                    },
                    borderStyle: {
                        borderWidth: 0, // override mojito defaults
                    },
                },
                title: {
                    padding: 0, // override mojito defaults
                },
                titleText: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    ...PALETTE.DIALOGS_TITLE_TEXT,
                },
            },
            closeButtonContainer: {
                style: {
                    right: 0,
                    top: 'initial',
                    bottom: 'calc(100% + 8px)',
                    left: 'initial',
                },
            },
            closeButton: generateCloseButton(PALETTE.DIALOGS_CLOSE_BUTTON),
            _mobile_closeButton: generateCloseButton(PALETTE.DIALOGS_CLOSE_BUTTON_MOBILE, CLOSE_BUTTON_TYPES.CIRCULAR),
            disabledOverlay: {
                ...resolveBackground(PALETTE.DIALOGS_DISABLED_OVERLAY_BG),
            },
        },
        Overlay: {
            style: {
                container: {
                    fontWeight: FONT.WEIGHT_NORMAL,
                    fontFamily: FONT.FAMILY,
                    ...PALETTE.DIALOGS_DEFAULT_TEXT,
                },
                overlay: {
                    style: {
                        ...resolveBackground(PALETTE.DIALOGS_OVERLAY_BG),
                    },
                },
            },
        },
    };
}
